module.exports = __webpack_public_path__ + "img/weddingRingsFacettedConnections-emotion-02.9f56a13.webp";